module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/130ZoMG/media/FC-9781685620509.jpg?1693228932377",
      "alt": "This image is the cover for the book Abe's Place"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Abe's Place\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Wannasea Island is a universe almost unto itself. A small independent island, 45  minutes from the mainland. Abe Stolz has spent the entire 70  years of his life lost within the history of his family and the island. Abe knows that he should move forward but fears doing so will disconnect him from his wife and daughter, who were lost at sea 23 years before. Abe’s primary goal has become seeing that his granddaughter,  Beth, the only surviving member of his immediate family, does not have her life consumed by the island and family history in the same manner. Neither the progress of the island nor his granddaughter are in tune with Abe’s efforts.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      NG Rippel\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', [_vm._v("NG Rippel’s interest in writing was driven by a misguided impression that his great-uncle was writing deep thoughts into the small Scripto notepad which was kept in his front shirt pocket. At age of six, Rippel started doing the same, and continued the practice, despite learning that what Uncle George was writing were lines of information on upcoming weddings and funerals where he might be able to pick up a free meal. However, Rippel has continued the practice of writing lines in notepads for the past 65+ years.")]), _c('p', [_vm._v(" Rippel began writing words and being an observer of whatever surrounded him. At the age of 25, he became a realist and dedicated himself to increasing his understanding of reality. An effort which has continued ever since.")]), _c('p', [_vm._v("To learn more about NG Rippel, go to ngrippel.com.")]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0